module.exports = __webpack_public_path__ + "img/materialInventoryMgt.22f72e4c.svg";